export const addresses = {
  tokenGate: "0xb007167714e2940013EC3bb551584130B7497E22",
};
